<template>
  <div class="animated fadeIn" @keyup.enter="onFilter">
    <div class="form-group row">
      <div class="col-md-12">
        <label> Nome do arquivo:</label>
        <div class="input-group">
          <b-form-input type="text"
                        :placeholder="'Digite o Nome do arquivo'"
                        v-model="form.nomeOriginal.value"
                        :state="form.nomeOriginal.state"
                        autofocus
          />
        </div>
        <label> Data de envio:</label>
        <div class="input-group">
          <b-form-input type="date"
                        v-model="form.dataEnvio.value"
                        :state="form.dataEnvio.state"
          />
        </div>
      </div>
    </div>
    <div class="form-group row pt-3">
      <div class="col-md-12 pt-2">
        <button
          type="button"
          class="btn btn-third w-100"
          v-on:click="onFilter"
        >
          Filtrar
        </button>
      </div>
      <div class="col-md-12 pt-2">
        <button
          type="button"
          class="btn btn-default w-100"
          v-on:click="onClearFilters"
        >
          Limpar Filtros
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import AttachSearch from './search.js'
export default AttachSearch
</script>



// WEBPACK FOOTER //
// src/views/private/attachments/components/search/search.vue